import React , {useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { ListGroup, Row, Col, Card, Navbar } from 'react-bootstrap'

import Meta from '../components/Meta'

//import OpenAILLM from '../components/custompieces/OpenAILLM'


import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";

  


export const NodesScreen = ({match, history}) => {
    const dispatch = useDispatch()
    const [selectedSection, setSelectedSection] = useState("") 
    const [data, setData] = useState([])
    const [viewMode, setViewMode] = useState('whatislaeyerz')





    useEffect(() => {}, [])

    return(
        
        <div style={{margin:"10px", padding:"10px"}}>
            <Meta title={'Laeyerz'} description={'Prebuilt Nodes for Laeyerz'}/>
            
            <Navbar></Navbar>
{/* 
            <Row>
                <Col style={{maxWidth:'15vw', minWidth:'15vw'}}>
                <ListGroup>
                    <ListGroup.Item style={{border:"None"}}>OpenAI Node</ListGroup.Item>
                    <ListGroup.Item style={{border:"None"}}>Chroma DB</ListGroup.Item>
                    <ListGroup.Item style={{border:"None"}}>MongoDB</ListGroup.Item>
                </ListGroup>
                
                </Col>
                <Col>

                <section id='openai-node' style={{marginBottom:'10px'}}>
                    <OpenAILLM />
                </section>
                            
                <section id='chroma-db' style={{marginBottom:'10px'}}>
                <Card style={{border:"None"}}>
                    <Card.Header style={{border:"None"}}>
                        <p className='h4'>Chroma DB</p>

                    </Card.Header>
                    <Card.Body>
                        Using the UI tab, test node with different inputs.

                    </Card.Body>
                </Card>
                </section>
               

               

                
                </Col>
            </Row> */}




 
        </div>
    )
}

export default NodesScreen


